exports.consoleLog = (a,b='()') => {
    if(process.env.GATSBY_ENV !== 'PRODUCTION'){
        return console.log(a,b);
    }else{
        return '';
    }  
}